import { connectRouter, RouterState } from 'connected-react-router';
/* eslint-disable import/no-extraneous-dependencies */
import { History } from 'history';
import { combineReducers, Reducer } from 'redux';
import authReducer from 'redux/auth/auth.persist.config';

import ChatMessagesReducer from './chat-messages/chat-messages.reducer';
import commonReducer from './common/common.reducer';
import FileReducer from './file/file.reducer';
import notificationReducer from './notification/notification.reducer';
import SearchReducer from './search/search.reducer';
// eslint-disable-next-line import/no-cycle
import SelectedAppointmentContactReducer from './selected-contact/selected-contact.reducer';
import settingsReducer from './settings/settings.reducer';
import { RootState } from './types';
import UserReducer from './user/user.reducer';

const createRootReducer = (history: History): Reducer<RootState> => {
  const rootState = {
    router: connectRouter(history) as Reducer<RouterState>,
    settings: settingsReducer,
    auth: authReducer,
    user: UserReducer.getReducer,
    common: commonReducer,
    file: FileReducer.getReducer,
    notification: notificationReducer,
    search: SearchReducer.getReducer,
    selectedAppointmentContact: SelectedAppointmentContactReducer.getReducer,
    chatMessages: ChatMessagesReducer.getReducer,
  };

  return combineReducers(rootState);
};

export default createRootReducer;
